import { applyRecurringRevenueFilters } from '../utils/apply-recurring-revenue-filters';
import {
  buildContractsByCustomer,
  buildCustomerMrrByMonth,
  classifyMonthlyMovements,
  computeRetentionPoints,
  prepareRows,
} from '../utils/chart-movements';
import { expandRecurringRevenueRows } from '../components/RecurringRevenueReportTable/recurring-revenue-report-row-expander';
import { extractMonthlyColumnKeys } from '../utils/recurring-revenue-month-keys';
import type {
  RecurringRevenueAggregationBundle,
  RecurringRevenueAggregationRequest,
} from './recurring-revenue-aggregation-types';

export function runRecurringRevenueAggregation(
  request: RecurringRevenueAggregationRequest,
): RecurringRevenueAggregationBundle {
  const filteredReport = applyRecurringRevenueFilters(request.report, request.filters);
  const expandedRows = expandRecurringRevenueRows(filteredReport);
  const allMonthKeys = extractMonthlyColumnKeys(filteredReport);

  const preparedRows = prepareRows(filteredReport, allMonthKeys);
  const customerMrrByMonth = buildCustomerMrrByMonth(preparedRows, allMonthKeys);
  const contractsByCustomer = buildContractsByCustomer(preparedRows);
  const monthlyMovementsByKey = classifyMonthlyMovements(
    customerMrrByMonth,
    contractsByCustomer,
    allMonthKeys,
  );
  const retentionPoints = computeRetentionPoints(allMonthKeys, monthlyMovementsByKey);

  const monthlyMovements = allMonthKeys
    .map((key) => monthlyMovementsByKey.get(key))
    .filter((movement): movement is NonNullable<typeof movement> => movement !== undefined);

  return {
    requestId: request.requestId,
    filteredReport,
    expandedRows,
    allMonthKeys,
    retentionPoints,
    monthlyMovements,
  };
}
